// transformation options according to the API
// https://github.com/picter/asset-processing-service/blob/main/functions/url-rewriter/src/index.ts
export type TransformationOptions = {
  w?: 1500 | 900 | 420 | 128 | 32;
  h?: 1500 | 900 | 420 | 128 | 32;
  dpr?: 1 | 2 | 3;
  rt?: "fill" | "fit";
  ar?: "16:9" | "4:3" | "3:2" | "9:16" | "3:4" | "2:3";
};

const defaultTransformationOptions: TransformationOptions = {
  w: 420,
  h: 420,
  dpr: 1,
};

export function buildImageUrl(
  srcUrl: string,
  { w, h, dpr, rt, ar }: TransformationOptions = defaultTransformationOptions,
): string {
  const url = new URL(`${srcUrl}:transform`);

  if (w) {
    url.searchParams.set("w", String(w));
  }

  if (h) {
    url.searchParams.set("h", String(h));
  }

  if (dpr) {
    url.searchParams.set("dpr", String(dpr));
  }

  if (rt) {
    url.searchParams.set("rt", rt);
  }

  if (ar) {
    url.searchParams.set("ar", ar);
  }

  return url.toString();
}
